import React, { useState } from "react";
import { customFetch } from "../../utils/Auth";
import BulkRegisterVADoctors from "./BulkRegisterVADoctors";
import { environment } from "../../config/environment";

export default function RegisterVADoctors() {
  const [fediamsecid, setFediamsecid] = useState("");
  const [org, setOrg] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [registrationMode, setRegistrationMode] = useState("single"); // "single" or "bulk"

  const registerVADoctor = async () => {
    try {
      setLoading(true);
      setMessage("");

      if (!fediamsecid || !org) {
        setMessage("❌ Both FEDIAMSecID and Organization are required");
        return;
      }

      const response = await customFetch(
        `${environment.apiUrl}/doctors/register-va-doctor`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            fediamsecid,
            org,
            username: localStorage.getItem("username") || "Unknown Admin",
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setMessage(`✅ ${data.message}`);
        console.log("Created doctor:", data.doctor);
        // Clear form
        setFediamsecid("");
        setOrg("");
      } else {
        setMessage(`❌ Error: ${data.error || data}`);
      }
    } catch (err) {
      console.error("Error registering VA doctor:", err);
      setMessage(`❌ Error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-6xl mx-auto">
      {/* Toggle Tabs */}
      <div className="mb-6 border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          <button
            onClick={() => setRegistrationMode("single")}
            className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
              ${
                registrationMode === "single"
                  ? "border-ktx-purple text-ktx-purple"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }
            `}
          >
            Single Registration
          </button>
          <button
            onClick={() => setRegistrationMode("bulk")}
            className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
              ${
                registrationMode === "bulk"
                  ? "border-ktx-purple text-ktx-purple"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }
            `}
          >
            Bulk Registration
          </button>
        </nav>
      </div>

      {/* Conditional Rendering based on mode */}
      {registrationMode === "single" ? (
        <div className="max-w-2xl mx-auto">
          <div className="bg-white shadow-md rounded-lg p-6 mb-4">
            {/* FEDIAMSecID Input */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                FEDIAMSecID (NPI) <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={fediamsecid}
                onChange={(e) => setFediamsecid(e.target.value)}
                placeholder="Enter FEDIAMSecID"
                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-ktx-purple focus:border-ktx-purple"
              />
              <p className="text-xs text-gray-500 mt-1">
                Email will be: {fediamsecid ? `${fediamsecid}@test.com` : "N/A"}
              </p>
            </div>

            {/* Organization Input */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Organization <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={org}
                onChange={(e) => setOrg(e.target.value)}
                placeholder="Enter Organization (e.g., VA-KC)"
                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-ktx-purple focus:border-ktx-purple"
              />
            </div>

            {/* Submit Button */}
            <button
              onClick={registerVADoctor}
              disabled={loading || !fediamsecid || !org}
              className="w-full bg-ktx-purple text-white py-2 px-4 rounded-md hover:bg-ktx-navy disabled:bg-gray-400 disabled:cursor-not-allowed font-semibold"
            >
              {loading ? "Registering..." : "Register VA Doctor"}
            </button>

            {/* Message Display */}
            {message && (
              <div
                className={`mt-4 p-3 rounded-md ${
                  message.includes("✅")
                    ? "bg-green-100 text-green-800"
                    : "bg-red-100 text-red-800"
                }`}
              >
                {message}
              </div>
            )}
          </div>

          {/* Info Box */}
          <div className="bg-blue-50 border border-blue-200 p-4 rounded-md">
            <h3 className="font-semibold text-blue-900 mb-2">
              Doctor Details:
            </h3>
            <ul className="text-sm text-blue-800 space-y-1">
              <li>
                • <strong>Name:</strong> placeholder
              </li>
              <li>
                • <strong>Email:</strong> {fediamsecid}@test.com
              </li>
              <li>
                • <strong>Specialty:</strong> VA Tech Sprint
              </li>
              <li>
                • <strong>QA:</strong> Automatic
              </li>
              <li>
                • <strong>Model:</strong> English
              </li>
              <li>
                • <strong>Turnaround:</strong> Real Time
              </li>
              <li>
                • <strong>Super Org:</strong> VA
              </li>
              <li>
                • <strong>Subscribed:</strong> Yes
              </li>
            </ul>
          </div>
        </div>
      ) : (
        <BulkRegisterVADoctors />
      )}
    </div>
  );
}
